module.exports = __webpack_public_path__ + "media/images/icons/outlined/retweet-b4792d1370d915cbed6e3e462a67fb0c.svg";